import * as yup from 'yup'

export const schema = yup.object().shape({
  content: yup.string().richTextRequired(),
})

export default schema
